import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NSNotFoundPage } from "namirasoft-site-react";
import { NamirasoftSMSSenderServer } from "namirasoft-sms-sender";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { SMSSenderLayout } from "./SMSSenderLayout";
import { SMSSenderRoutes } from "./SMSSenderRoutes";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import ProviderEditPage from "./pages/ProviderEditPage";
import ProviderListPage from "./pages/ProviderListPage";
import ProviderViewPage from "./pages/ProviderViewPage";
import SendPage from "./pages/SendPage";
import SentListPage from "./pages/SentListPage";
import VerifySMSPage from "./pages/VerifySMSPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_SMS_SENDER}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_SMS_SENDER = new EnvService("REACT_APP_BASE_URL_SMS_SENDER", true).getString();

            let sms_sender = new NamirasoftSMSSenderServer(REACT_APP_BASE_URL_SMS_SENDER, result.account.token_manager, result.notifier.onError);

            let servers = { sms_sender };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={SMSSenderRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={SMSSenderRoutes.ProviderList} element={<ProviderListPage {...result} servers={servers} />} />
                            <Route path={SMSSenderRoutes.ProviderNew} element={<ProviderEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={SMSSenderRoutes.ProviderView(":id")} element={<ProviderViewPage {...result} servers={servers} />} />
                            <Route path={SMSSenderRoutes.ProviderEdit(":id")} element={<ProviderEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={SMSSenderRoutes.ProviderCopy(":id")} element={<ProviderEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={SMSSenderRoutes.SentList} element={<SentListPage {...result} servers={servers} />} />

                            <Route path={SMSSenderRoutes.Send(null)} element={<SendPage {...result} servers={servers} />} />
                            <Route path={SMSSenderRoutes.Send(":id")} element={<SendPage {...result} servers={servers} />} />

                            <Route path={SMSSenderRoutes.Verify(":provider_id")} element={<VerifySMSPage {...result} servers={servers} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={SMSSenderRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <SMSSenderLayout {...props}>
                {props.children}
            </SMSSenderLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: true
            }
        }}
    />
}

export default Router;